import React from 'react'
import { useState, useContext } from 'react'
import { AppContext } from '../context/AppContext'
import {
    Switch,
    Route,
    Link, useLocation, Redirect
} from 'react-router-dom'

const MyLocation = () => {

  
    const {tripDetails, setTripDetails, setGeoAddress} = useContext(AppContext)
    
    const updateGeoAddress = (evt) => {
      evt.preventDefault()
      console.log(tripDetails.location)
      setGeoAddress(tripDetails.location)
    }
    

    const updatetripDetails = (evt) => {
      setTripDetails({...tripDetails, [evt.target.id]: evt.target.value})
    } 

    return (
      <div className="my-location-wrap">
          <form onSubmit={updateGeoAddress}>
            <fieldset className="form-row">
              <label for="location"><h4>Departure Address</h4></label>
              <input id="location" onBlur={updateGeoAddress} type="text" placeholder="Helsinki" onChange={updatetripDetails} value={tripDetails.location}></input>
            </fieldset>
          </form>
      </div>
    )
}

export default MyLocation